import React from "react";
import { BrowserRouter as Router, Link, Route, Routes, Navigate} from 'react-router-dom';
import { MdBrightness6, MdArticle, MdHome } from "react-icons/md";
import { GoBriefcase, GoMarkGithub } from "react-icons/go";
import { BsFillRssFill } from "react-icons/bs";
import Home from './pages/Home';
import Projects from './pages/Projects';
import Repo from './pages/Repo';
import MyCV from './pages/MyCV';
import { Promotion, Footer } from "./components/AllExportedComponent";

function App() {
  React.useEffect(() => { Promotion() }, []);

  return (
    <Router>

      <div className="flex Navbar">

        <nav className="flex w-full mx-auto px-4 sm:px-6 lg:px-8 bg-gray-800 shadow-lg">
            <div className="flex w-full flex-row items-center justify-between h-16">

              <div className="flex order-1 items-center">
                  <p translate="no" className="pointer-events-none text-gray-300 px-3 py-2 text-sm font-medium">bagussona.github.io</p>
              </div>
              
              <div className="flex flex-row order-3 items-center justify-between">
                <div className="md:top-0 md:relative bg-gray-800 shadow-[0_0_30px_-15px_rgba(0,0,0,1)] flex items-baseline text-center justify-end px-4 sm:px-6 lg:px-8 fixed inset-x-0 bottom-0">
                  <Link to="/" className="w-full h-16 md:w-24 md:h-8 flex flex-col items-center justify-center hover:bg-gray-700 text-gray-300 px-3 py-2 rounded-md">
                    <span className="md:hidden text-lg font-bold mb-1"><MdHome/></span>
                      <span className="text-sm font-medium mt-1">BERANDA</span>
                  </Link>
                  <Link to="/cv" className="w-full h-16 md:w-24 md:h-8 flex flex-col items-center justify-center text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md">
                    <span className="md:hidden text-sm font-bold mb-1"><BsFillRssFill/></span>
                        <span className="text-sm font-medium mt-1">CV</span>
                  </Link>
                  <Link to="/projects" className="w-full h-16 md:w-24 md:h-8 flex flex-col items-center justify-center text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md">
                    <span className="md:hidden text-lg font-bold mb-1"><GoBriefcase/></span>
                        <span className="text-sm font-medium mt-1">PROYEK</span>
                  </Link>
                  <Link to="/repos" className="w-full h-16 md:w-24 md:h-8 flex flex-col items-center justify-center text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md">
                    <span className="md:hidden text-lg font-bold mb-1"><GoMarkGithub/></span>
                        <span className="text-sm font-medium mt-1">REPO</span>
                  </Link>
                  <a href="https://bagussona.github.io/blog/" className="w-full h-16 md:w-24 md:h-8 flex flex-col items-center justify-center text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md">
                    <span className="md:hidden text-lg font-bold mb-1"><MdArticle/></span>
                        <span className="text-sm font-medium mt-1">BLOG </span>
                  </a>
                </div>

                <div className="flex order-2 items-center">
                  <button type="button" className="justify-center p-3 rounded-md text-gray-400 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                    <span className="text-lg font-bold"><MdBrightness6/></span>
                  </button>
                </div>

              </div>
            
          </div>
        </nav>

      </div>
      <div className="flex flex-col">
        <div className="overflow-y-hidden font-['nunito'] px-6 lg:px-8 pb-28">
          <Routes>
            <Route path="/" element={<Home/>}></Route>
            <Route path="projects" element={<Projects/>}></Route>
            <Route path="repos" element={<Repo/>}></Route>
            <Route path="cv" element={<MyCV />}></Route>
            <Route path="*" element={<Navigate to="/" />}></Route>
          </Routes>
        </div>
        <div className="hidden md:flex flex-col justify-center items-center h-16 text-center mt-6 pt-6 px-4 sm:px-6 lg:px-8 mb-8 border-t border-slate-200">
            <Footer/>
        </div>
      </div>
    </Router>
  );
}

export default App;
